import { Controller } from '@hotwired/stimulus';

const DONE = 'ui-ai-loading-modal__step--done';
const ACTIVE = 'ui-ai-loading-modal__step--active';
const STATUS = { done: 'Done', active: 'In progress', pending: '' };

export default class extends Controller {
  static targets = ['step', 'status'];

  static values = { delay: Number, jitter: Number };

  connect() {
    this.active = 0;
    this.paint();

    // Rendered hidden and shown by its owner, so the run starts when it appears — and starts
    // over: a failed extraction hides the modal without unmounting it, leaving the steps
    // where they stopped, and a retry would otherwise open on a finished list.
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.restart();
      else this.halt();
    });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    this.halt();
  }

  restart() {
    this.halt();
    this.active = 0;
    this.paint();
    this.schedule();
  }

  halt() {
    clearTimeout(this.timer);
    this.timer = null;
  }

  // The last step has no successor: it keeps spinning until the modal closes.
  schedule() {
    if (this.timer || this.active >= this.stepTargets.length - 1) return;

    this.timer = setTimeout(() => {
      this.timer = null;
      this.active += 1;
      this.paint();
      this.schedule();
    }, this.delayValue + Math.random() * this.jitterValue);
  }

  paint() {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle(DONE, index < this.active);
      step.classList.toggle(ACTIVE, index === this.active);
      if (index === this.active) step.setAttribute('aria-current', 'step');
      else step.removeAttribute('aria-current');

      let status = STATUS.pending;
      if (index < this.active) status = STATUS.done;
      else if (index === this.active) status = STATUS.active;
      this.statusTargets[index].textContent = status;
    });
  }
}
